module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f60a.6f75b58e.svg";